import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocuments } from "../../redux/actions/actionDocument";
import InDocumentCreate from "../InDocuments/inDocumentCreate";


export default function InDocumentChildCard({ item, name, descrip, quantity, itemsDocument, form, missing, 
                                      handleEnterItem, handleQuantity}) {

  

  return (
    <div>
      <div className="flex border-b-2 border-slate-500 text-[9pt]">        
        <div className="w-1/3">
          {name}
        </div>
        <div className="w-2/5">
          {descrip}
        </div>
        <div className="w-22 text-center">
          <div className="w-20">{quantity}</div>
        </div>
        <div className="w-22">
        <input 
          className="border rounded w-20 text-center bg-gray-700" 
          type="number" name="quantity" 
          onChange={handleQuantity} 
          onKeyUp={(x) => handleEnterItem(x, quantity, item)}
          
          />
        </div>
        <div>
          {form.quantityItems.map(e => {
            if(e.item === item){
              return (
                <div className="w-20 text-center text-green-600">{e.quantity}</div>
              )
            }
          })}
        </div>
      </div>
    </div>
  );
}
